import { useEffect } from 'react'

import {
  getBoundRange,
  SelectedMarker,
  useMapStore,
  useSelectedMarkerStore,
} from '@/entities/map'
import { mapManager, useCircle } from '@/shared/lib'

export const CIRCLE_OPTIONS = {
  landmark: {
    radius: 700,
    strokeColor: '#2375F6',
    strokeWeight: 1,
    fillColor: '#2375F6',
    fillOpacity: 0.2,
  },
  subway: {
    radius: 700,
    strokeColor: '#FEB519',
    strokeWeight: 1,
    fillColor: '#FEB519',
    fillOpacity: 0.2,
  },
}

export const useBoundCircle = () => {
  const { createCircle, removeCircle, getCircleBounds } = useCircle()

  const selectedMarker = useSelectedMarkerStore(state => state.selectedMarker)
  const mapActions = useMapStore(state => state.actions)

  const drawCircle = (markerProp?: SelectedMarker) => {
    const marker = markerProp ?? selectedMarker

    if (!marker) return

    createCircle({
      ...CIRCLE_OPTIONS[marker.type],
      center: marker.position,
      render: true,
    })
  }

  const updateBounds = () => {
    const bounds = getCircleBounds()

    if (bounds) {
      mapActions.updateParams(getBoundRange(bounds))
    }
  }

  const resetBounds = () => {
    mapManager.withMap(map => {
      const bounds = map.getBounds()
      mapActions.updateParams(getBoundRange(bounds))
    })
  }

  const handleSelectedMarkerChange = (updatedMarker: SelectedMarker | null) => {
    removeCircle()

    if (updatedMarker) {
      drawCircle(updatedMarker)
      updateBounds()
    } else {
      resetBounds()
    }
  }

  useEffect(
    () =>
      useSelectedMarkerStore.subscribe(
        state => state.selectedMarker,
        handleSelectedMarkerChange,
      ),
    [],
  )
}
